function cov_1n8q6v0d3l() {
  var path = "/app/src/components/v2/button/button.tsx";
  var hash = "a281464437b69ecb57366c921d83d00d11f4ca30";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/v2/button/button.tsx",
    statementMap: {
      "0": {
        start: {
          line: 15,
          column: 2
        },
        end: {
          line: 26,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "Button",
        decl: {
          start: {
            line: 14,
            column: 16
          },
          end: {
            line: 14,
            column: 22
          }
        },
        loc: {
          start: {
            line: 14,
            column: 74
          },
          end: {
            line: 27,
            column: 1
          }
        },
        line: 14
      }
    },
    branchMap: {},
    s: {
      "0": 0
    },
    f: {
      "0": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "a281464437b69ecb57366c921d83d00d11f4ca30"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1n8q6v0d3l = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1n8q6v0d3l();
import cn from 'classnames';
import React from 'react';
import { Typography } from '../typography';
import styles from './styles.css';
export function Button(_ref) {
  var className = _ref.className,
    children = _ref.children,
    onClick = _ref.onClick,
    testAttr = _ref.testAttr;
  cov_1n8q6v0d3l().f[0]++;
  cov_1n8q6v0d3l().s[0]++;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: cn(styles.button, className),
    onClick: onClick,
    "data-test": testAttr
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    bold: true,
    className: styles.buttonText
  }, children));
}